/* eslint-disable import/prefer-default-export */
/* eslint-disable default-param-last */
import {
  INFO_USER,
  LOGIN_USER,
} from '../types';

const initialState = {
  sub: sessionStorage.getItem('sub'),
  infoUser: JSON.parse(sessionStorage.getItem('infoUser')),
};

export const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return {
        ...state,
        sub: action.payload,
      };
    case INFO_USER:
      return {
        ...state,
        infoUser: action.payload,
      };
    default:
      return state;
  }
};
